import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: theme.spacing(1.25),
  marginRight: theme.spacing(1.75),
  backgroundColor: theme.palette.primary.main,
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(0.5, 0.75, 0.25, 0.75),
  fontWeight: 700,
}));

export default StyledTypography;
